import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getGeolocations } from './helpers'

import { dv360TargetingSelector } from '../../../../../../modules/selectors/dv360Constants'

const GeolocationSectionPreview = () => {
  const targeting = useSelector(dv360TargetingSelector)

  const geolocations = useMemo(() => getGeolocations(targeting), [targeting])

  return (
    <p>{!!geolocations.length ? geolocations.map(({ label, value }) => <span key={value}>{label}</span>) : null}</p>
  )
}

export default GeolocationSectionPreview
